import styled from 'styled-components';
import { spacing } from '@landr/maestro';

export const WaveformWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    min-height: ${spacing('jb')};
    height: ${spacing('jb')};
    justify-content: flex-start;
    width: 100%;

    > div {
        width: 100%;
        padding: 0 ${spacing('sm')};
        box-sizing: border-box;
    }

    span {
        width: ${spacing('xxl')};
    }
`;

export const WaveformContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    max-width: calc(100% - ${spacing('xxl')});
`;
